import { BotButtonPayloadType } from '@gem/models/botModel';

import Tasks from 'APP/Tasks';
import { IButtonPayloadModel } from 'STORE/Messages/Message/Payload/ButtonsPayload/ButtonsPayload';
import { CommandButtonPayload } from 'STORE/Messages/Message/Payload/ButtonsPayload/CommandButtonPayload';
import { ButtonsSelectedPayload } from 'STORE/Messages/Message/Payload/ButtonsSelectedPayload/ButtonsSelectedPayload';

interface IBaseCommandButtonPresenterProps {
  groupId: string;
  button: IButtonPayloadModel;
}

interface IBaseCommandButtonPresenter {
  onClick(): void;
}

export const useBaseCommandButtonPresenter = ({
  button,
  groupId,
}: IBaseCommandButtonPresenterProps): IBaseCommandButtonPresenter => {
  const onClick = (): void => {
    const payload = button.payload as CommandButtonPayload;
    Tasks.messaging.createNewMessages(groupId, [
      {
        payload: new ButtonsSelectedPayload({
          button: {
            title: button.title,
            id: payload.id,
            payload: {
              type: BotButtonPayloadType.Command,
              botId: payload.botId,
              id: payload.id,
            },
          },
        }),
      },
    ]);
  };

  return { onClick };
};
